// Client & Supplier Types
// Unified interface for both clients (customers) and suppliers (vendors)

export type ClientType = 'client' | 'supplier' | 'both';

export interface Client {
  id: string;
  company_id: string;
  
  // Basic Information
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  
  // Type: Client, Supplier, or Both
  type: ClientType;
  
  // Tax Information (Algerian)
  tax_id?: string;  // NIF (Numéro d'Identification Fiscale)
  nrc?: string;     // Numéro de Registre de Commerce
  nis?: string;     // Numéro d'Identification Statistique
  
  // Supplier-Specific Fields
  payment_terms?: string;   // e.g., "Net 30", "Cash", "Net 60"
  credit_limit?: number;    // Credit limit for this supplier
  
  // Metadata
  notes?: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
}

// Helper type guards
export function isClient(client: Client): boolean {
  return client.type === 'client' || client.type === 'both';
}

export function isSupplier(client: Client): boolean {
  return client.type === 'supplier' || client.type === 'both';
}

// Display labels
export const CLIENT_TYPE_LABELS: Record<ClientType, { fr: string; ar: string }> = {
  client: {
    fr: 'Client',
    ar: 'عميل',
  },
  supplier: {
    fr: 'Fournisseur',
    ar: 'مورد',
  },
  both: {
    fr: 'Client & Fournisseur',
    ar: 'عميل و مورد',
  },
};

// Payment terms options (common in Algeria)
export const PAYMENT_TERMS_OPTIONS = [
  { value: 'cash', label: 'Comptant / Cash', labelAr: 'نقدي' },
  { value: 'net_7', label: 'Net 7 jours', labelAr: '7 أيام' },
  { value: 'net_15', label: 'Net 15 jours', labelAr: '15 يوم' },
  { value: 'net_30', label: 'Net 30 jours', labelAr: '30 يوم' },
  { value: 'net_60', label: 'Net 60 jours', labelAr: '60 يوم' },
  { value: 'net_90', label: 'Net 90 jours', labelAr: '90 يوم' },
  { value: 'custom', label: 'Personnalisé / Custom', labelAr: 'مخصص' },
] as const;
